import { Skeleton } from "@mui/material";
import React from "react";
import {
  CurrentCount,
  MainContainerDiv,
  MainContainerHeading,
} from "./Dashboard.style";
import CurrentTrialVolunteers from "../../Images/current_trial_volunteers.png";

const CurrentStudiesDashboard = ({ data, isLoading }) => {
  // console.log("🚀 ~ CurrentStudiesDashboard ~ data:", data);
  return (
    <>
      <MainContainerDiv
        style={{ background: "linear-gradient(to right,   #8B4513, #56AB2F)" }}
      >
        <div>
          <MainContainerHeading>Current Studies</MainContainerHeading>

          {isLoading ? (
            <CurrentCount>
              {/* <SyncLoader color="#4e97fd" size={8} /> */}
              <Skeleton animation="wave" />
            </CurrentCount>
          ) : (
            <div>
              {data?.map((currentTrial, index) => (
                <div key={index} style={{ display: "flex", gap: "5px" }}>
                  <p>{currentTrial?.protocol_title}</p>
                  <p>( {currentTrial?.number_of_volunteres} )</p>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <img
            style={{
              height: "6rem",
              width: "6rem",
            }}
            src={CurrentTrialVolunteers}
            alt=""
          />
        </div>
      </MainContainerDiv>
    </>
  );
};

export default CurrentStudiesDashboard;
